export const MEGABYTE = 1024 * 1024;

export const DEFAULT_UPLOAD_FILE_MAX_SIZE_MB = 10;
export const DEFAULT_UPLOAD_FILE_MAX_SIZE_BYTES = DEFAULT_UPLOAD_FILE_MAX_SIZE_MB * MEGABYTE;
